import * as yup from 'yup';
const MemberNotesSchema = yup
    .object()
    .shape({
    notes: yup.string().required()
})
    .defined();
export default MemberNotesSchema;
